export default __webpack_public_path__ + "media/metabolicMenSeo.44312bc5a8a23c52fcea2e172c2e9821.webp";